module.exports = __webpack_public_path__ + "img/doctor.f4a2eb61.svg";